import React from 'react';
import { Plus, Trash2 } from 'lucide-react';

export default function CuantiasCotizacionSection({
  cuantias,
  isReadOnly,
  onCuantiaChange,
  onRemoveCuantia,
  onAddCuantia
}) {
  return (
    <>
      <h4 style={{ fontSize: '1rem', marginTop: '2.5rem', marginBottom: '1rem', color: 'var(--primary-dark)', borderBottom: '1px solid var(--border-color)', paddingBottom: '0.5rem' }}>
        Cuantías Asociadas
      </h4>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '1.5rem' }}>
        {cuantias.length === 0 && <p style={{ color: 'var(--gray-500)', fontSize: '0.85rem' }}>No hay cuantías agregadas.</p>}
        {cuantias.map((c, idx) => (
          <div key={`cuantia-${idx}`} style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
            <div style={{ width: 180, display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: '0.7rem', color: 'var(--gray-500)', marginBottom: 2 }}>Tipo de Cuantía</span>
              <select
                value={c.tipo_cuantia}
                onChange={e => onCuantiaChange(idx, 'tipo_cuantia', e.target.value)}
                style={{ padding: '8px', fontSize: '0.9rem', borderRadius: 8, width: '100%' }}
                disabled={isReadOnly}
              >
                <option value="">Seleccione...</option>
                <option value="Herencia">Herencia</option>
                <option value="Compraventa">Compraventa</option>
                <option value="Hipoteca">Hipoteca</option>
              </select>
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: '0.7rem', color: 'var(--gray-500)', marginBottom: 2 }}>Predio / Bien (Descripción)</span>
              <input
                type="text"
                placeholder="Ej. Fojas 123, Número 456, Año 2023"
                value={c.descripcion}
                onChange={e => onCuantiaChange(idx, 'descripcion', e.target.value)}
                style={{ padding: '8px 12px', fontSize: '0.9rem', borderRadius: 8, width: '100%' }}
                disabled={isReadOnly}
              />
            </div>
            <div style={{ width: 150, position: 'relative', display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: '0.7rem', color: 'var(--gray-500)', marginBottom: 2 }}>Valor / Monto</span>
              <div style={{ position: 'relative' }}>
                <span style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: 'var(--gray-500)', fontSize: '0.9rem' }}>$</span>
                <input
                  type="number"
                  value={c.precio_unitario || ''}
                  onChange={e => onCuantiaChange(idx, 'precio_unitario', e.target.value)}
                  placeholder="0"
                  min="0"
                  style={{ padding: '8px 12px 8px 24px', textAlign: 'right', fontWeight: 600, borderRadius: 8, width: '100%' }}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            {!isReadOnly && (
              <button onClick={() => onRemoveCuantia(idx)} className="icon-btn text-error no-print" style={{ padding: 8, marginTop: 16 }}>
                <Trash2 size={18} />
              </button>
            )}
          </div>
        ))}

        {!isReadOnly && (
          <button
            onClick={onAddCuantia}
            className="btn btn-secondary btn-sm no-print"
            style={{ alignSelf: 'flex-start', marginTop: '0.5rem', background: 'var(--primary-light)', color: '#ffffff', border: '1px solid var(--primary-dark)' }}
          >
            <Plus size={14} /> Agregar cuantía
          </button>
        )}
      </div>
    </>
  );
}
